<form #form="ngForm">
    <div *ngIf="activeProperty" class="ms-4">
        <div class="d-flex justify-content-between align-items-start mb-3">
            <h3>{{ 'MODULES.SPEC_GENERATION.FORM_TITLE' | translate }}</h3>
            <a
                class="d-flex justify-content-end align-items-center ms-1"
                target="_blank"
                rel="noopener"
                href="https://docs.apeer.com/documentation/module-specification"
            >
                {{ 'MODULES.SPEC_GENERATION.CHECK_EXAMPLE' | translate }}
                <ca-icon name="external-link" size="specType" class="ms-2"></ca-icon>
            </a>
        </div>
        <div class="d-flex justify-content-between align-items-center">
            <div class="w-50">
                <div class="d-flex flex-column-reverse">
                    <input
                        required
                        id="propertyName"
                        type="text"
                        class="form-control"
                        name="propertyName"
                        data-uit="property-name"
                        [ngModel]="activeProperty?.uiProperty?.label"
                        (ngModelChange)="updateLabelAndKeyInSpec($event)"
                        [ngClass]="nameDescRef.errors ? 'has-error' : ''"
                        #nameDescRef="ngModel"
                    />
                    <label for="propertyName"
                        >{{ activePropertyTypeLabel }} {{ 'MODULES.SPEC_GENERATION.NAME' | translate }}<span class="red ps-1">*</span></label
                    >
                </div>
                <div class="d-flex justify-content-between mt-1">
                    <small>{{ 'MODULES.SPEC_GENERATION.VISIBLE_TO_USER' | translate }}</small>
                    <ca-form-validation-error-presenter class="mt-0" [validationErrors]="nameDescRef.errors"></ca-form-validation-error-presenter>
                </div>
            </div>
            <div>
                <div class="d-flex flex-column-reverse">
                    <input
                        disabled
                        readonly
                        id="propertyKey"
                        type="text"
                        class="form-control disabled"
                        name="propertyKey"
                        data-uit="property-key"
                        [value]="activeProperty?.key"
                    />
                    <label for="propertyKey"
                        >{{ 'MODULES.SPEC_GENERATION.GENERATED' | translate }} {{ activePropertyTypeLabel }}
                        {{ 'MODULES.SPEC_GENERATION.KEY' | translate }}</label
                    >
                </div>
                <small>{{ 'MODULES.SPEC_GENERATION.TO_USE_IN_CODE' | translate: { inputOutput: activePropertyTypeLabel } }}</small>
            </div>
        </div>
        <div class="mt-2">
            <div class="d-flex flex-column-reverse">
                <input
                    id="propertyDescription"
                    required
                    type="text"
                    class="form-control"
                    name="propertyDescription"
                    data-uit="property-description"
                    [ngModel]="activeProperty?.uiProperty?.description"
                    (ngModelChange)="updateDescription($event)"
                    #descRef="ngModel"
                    [ngClass]="descRef.errors ? 'has-error' : ''"
                />
                <label for="propertyDescription"
                    >{{ activePropertyTypeLabel }} {{ 'MODULES.SPEC_GENERATION.DESCRIPTION' | translate }}<span class="red ps-1">*</span></label
                >
            </div>
            <div class="d-flex justify-content-between mt-1">
                <small>{{ 'MODULES.SPEC_GENERATION.VISIBLE_TO_USER_AS_TOOLTIP' | translate }}</small>
                <ca-form-validation-error-presenter class="mt-0" [validationErrors]="descRef.errors"></ca-form-validation-error-presenter>
            </div>
        </div>
        <div class="mt-2" *ngIf="activeProperty?.specType">
            <div class="d-flex flex-column-reverse form-group">
                <ng-select
                    placeholder="Choose Data Type"
                    name="dataType"
                    [clearable]="false"
                    appendTo="body"
                    [searchable]="false"
                    [ngModel]="activeProperty?.specType"
                    (change)="changeDataType($event)"
                    data-uit="select-type"
                    required
                    [ngClass]="dataTypeRef.errors ? 'has-error' : ''"
                    #dataTypeRef="ngModel"
                >
                    <ng-option *ngFor="let propType of dataTypesToShow" [value]="propType.value">{{ propType.label }}</ng-option>
                </ng-select>
                <label for="propertyType">{{ activePropertyTypeLabel }} {{ 'MODULES.SPEC_GENERATION.TYPE' | translate }}<span class="red ps-1">*</span></label>
            </div>
            <ca-form-validation-error-presenter [validationErrors]="dataTypeRef.errors"></ca-form-validation-error-presenter>
        </div>
        <div *ngIf="isActivePropertyInput && uiControlTypes.length > 0 && activeProperty?.uiControlType !== 'none'">
            <div class="d-flex flex-column-reverse mt-3 form-group">
                <ng-select
                    placeholder="{{ 'MODULES.SPEC_GENERATION.CHOOSE_UI_TYPE' | translate }}"
                    name="inputControl"
                    [clearable]="false"
                    [ngModel]="activeProperty?.uiControlType"
                    [searchable]="false"
                    (change)="changeUiControlType($event)"
                    data-uit="select-ui"
                    required
                    #uiTypeRef="ngModel"
                >
                    <ng-option *ngFor="let control of uiControlTypes" [value]="control.value">{{ control.label }}</ng-option>
                </ng-select>
                <label>{{ 'MODULES.SPEC_GENERATION.CHOOSE_UI_TYPE' | translate }}<span class="red ps-1">*</span></label>
            </div>
            <ca-form-validation-error-presenter [validationErrors]="uiTypeRef.errors"></ca-form-validation-error-presenter>
        </div>
        <div *ngIf="activeProperty?.uiControlType === 'radiobuttongroup' || activeProperty?.uiControlType === 'dropdown'">
            <div class="font-s">{{ 'MODULES.SPEC_GENERATION.SINGLE_CHOICE_OPTION_DESC' | translate }}</div>
            <span>{{ 'MODULES.SPEC_GENERATION.SET_PROPERTIES' | translate }} {{ 'MODULES.SPEC_GENERATION.ONE_ELEM_AS_DEFAULT' | translate }}</span>
            <table class="table table-sm table-borderless mt-3" *ngIf="activeProperty?.widgetSpecificUiProperty">
                <thead>
                    <tr>
                        <th>
                            {{ 'MODULES.SPEC_GENERATION.LABEL' | translate }} <small>{{ 'MODULES.SPEC_GENERATION.VISIBLE_TO_USER' | translate }}</small> *
                        </th>
                        <th class="text-center">{{ 'MODULES.SPEC_GENERATION.DEFAULT_VALUE' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of getDropdownOrRadioItems(); let i = index">
                        <td>
                            <input
                                type="text"
                                [name]="'choiceLabel' + i"
                                [id]="'choice-label-' + i"
                                class="form-control option"
                                required
                                (focusout)="adjustKeyToLabel(item)"
                                [(ngModel)]="item.label"
                                placeholder="Label *"
                                #choiceLabelRef="ngModel"
                            />
                            <ca-form-validation-error-presenter [validationErrors]="choiceLabelRef.errors"></ca-form-validation-error-presenter>
                        </td>
                        <td class="d-flex align-items-center">
                            <button
                                type="button"
                                class="btn btn-secondary"
                                [class.active]="activeProperty?.specProperty.default === item.key"
                                (click)="setDefaultOption(item.key)"
                            >
                                {{ 'MODULES.SPEC_GENERATION.DEFAULT' | translate }}
                            </button>
                            <a class="ms-3 delete-choice-item" (click)="deleteItem(i)"></a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <button type="button" (click)="addItem()" class="btn btn-primary">{{ 'MODULES.SPEC_GENERATION.ADD_ITEM' | translate }}</button>
        </div>
        <ca-ui-widget-demo-controls
            *ngIf="shouldShowUiDemoControl()"
            [activeProperty]="activeProperty"
            (onFormValidityChanged)="handleWidgetDemoFormValidity($event)"
        ></ca-ui-widget-demo-controls>
        <div *ngIf="isSpecTypeFile" class="mt-3">
            <span>{{ 'MODULES.SPEC_GENERATION.SUPPORTED_FILE_TYPE' | translate }}<span class="red ps-1">*</span></span>
            <div class="d-flex flex-column mb-2">
                <ca-input-checkbox class="mt-2" [name]="'category_all'" [ngModel]="isAllFilesChecked" (ngModelChange)="checkOrUncheckAllFiles($event)">
                    {{ 'MODULES.SPEC_GENERATION.ALLOW_ALL_FILES' | translate }}
                </ca-input-checkbox>
                <div class="d-flex flex-column" *ngIf="!isAllFilesChecked">
                    <ca-input-checkbox
                        *ngFor="let category of fileCategoriesMap | keyvalue"
                        [name]="'category_' + category.key"
                        [ngModel]="fileCategoriesMap.get(category.key)"
                        (ngModelChange)="checkOrUncheckFileCategory($event, category.key)"
                    >
                        {{ category.key | titlecase }}
                    </ca-input-checkbox>
                </div>
            </div>
            <div class="d-flex flex-column" *ngIf="supportedFileTypesOfSelectedCategoriesMap.size > 0">
                <span class="mb-2" *ngIf="supportedFileTypesOfSelectedCategoriesMap.size > 0"
                    >{{ 'MODULES.SPEC_GENERATION.CHOOSE_FILE_FORMATS' | translate }}<span class="red ps-1">*</span></span
                >
                <div *ngFor="let fileTypeEntry of supportedFileTypesOfSelectedCategoriesMap | keyvalue">
                    <ca-input-checkbox
                        [name]="'fileType_' + fileTypeEntry.key"
                        [ngModel]="fileTypeEntry.value"
                        (ngModelChange)="checkOrUncheckFileFormat($event, fileTypeEntry.key)"
                    >
                        {{ fileTypeEntry.key }}
                    </ca-input-checkbox>
                </div>
            </div>
        </div>
    </div>
    <div class="requirements m-auto font-l align-content-center h-100" [attr.hidden]="!propertyDefinitionComplete ? true : null">
        <span class="font-l item-plus">+</span>
        <span class="item-requirements-title">{{ 'MODULES.SPEC_GENERATION.MODULE_REQUIREMENTS.TITLE' | translate }}</span>
        <span class="font-l item-equals">=</span>
        <ca-icon name="file" size="l" class="item-file-icon"></ca-icon>
        <div class="item-checkboxes">
            <ca-input-checkbox class="form-control mb-2" [(ngModel)]="gpuUsage" name="gpuUsage" data-uit="gpu-usage-checkbox">{{
                'MODULES.SPEC_GENERATION.MODULE_REQUIREMENTS.GPU_USAGE' | translate
            }}</ca-input-checkbox>
            <ca-input-checkbox class="form-control mb-2" [(ngModel)]="internetAccess" name="internetAccess" data-uit="internet-access-checkbox">{{
                'MODULES.SPEC_GENERATION.MODULE_REQUIREMENTS.INTERNET_ACCESS' | translate
            }}</ca-input-checkbox>
        </div>
        <span class="item-requirements-spec-file-text">{{ 'MODULES.SPEC_GENERATION.MODULE_REQUIREMENTS.MODULE_SPECIFICATION_FILE' | translate }}</span>
    </div>
</form>
